import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextField } from '@mui/material';
var DateInput = function (_a) {
    var label = _a.label, error = _a.error, _b = _a.disabled, disabled = _b === void 0 ? false : _b, defaultValue = _a.defaultValue, onChange = _a.onChange;
    return (_jsx(TextField, { type: "date", variant: "outlined", "data-testid": "date-input", label: label, disabled: disabled, defaultValue: defaultValue, onChange: function (e) { return onChange(e.target.value); }, slotProps: { inputLabel: { shrink: true } }, error: !!error, helperText: error, required: true, fullWidth: true }));
};
export default DateInput;
